<template>
  <vue-apex-charts
    ref="brandpinChartBar"
    :height="barChartHeight"
    v-on:update:heightSetting="setHeight"
    :options="chartOptionsBar"
    :series="series"
  />
</template>

<script>
import VueApexCharts from "vue-apexcharts";



export default {
  name: "BrandPinChartBar",
  components: {
    VueApexCharts,
  },
  data() {
    return {
      barChartHeight: 45*21,
      chartOptionsBar: {
        chart: {
          type: "bar",
          background: '#FBFBFB',
          toolbar:{
            show: false
          },
          sparkline:{
            enabled: true
          }
        },
        grid:{
          show: true,
          // yaxis:{
          //   lines:{
          //     show: false
          //   }
          // },
        },
        dataLabels: {
          enabled: true,
          fontFamily: "NanumBarunGothic !important",
          textAnchor: 'start',
          style: {
                // colors: ['#5e5873'],
                colors: ['#333'],
              },
          formatter: function (val, opt) {
                return opt.w.globals.labels[opt.dataPointIndex] + ":  " + Math.round(val) + "%"
                // return Math.round(val) + "%"
              },
          offsetX: 0,
          dropShadow: {
            enabled: true
          }
        },
        stroke: {
              width: 1,
              colors: ['#fff']
            },
        xaxis: {
          categories: [],
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        tooltip: {
          shared: true,
          followCursor: true,
          intersect: false,
          x: {
            show: true
          },
          y: {
            formatter(val){
              return val
            },
            title: {
              formatter: function () {
                return ''
              }
            },
          },
        },
        legend: {
          show: false,
          position: "top",
          horizontalAlign: "left",
          offsetX: 0,
          fontSize: "12px",
          fontFamily: "NanumBarunGothic !important",
          itemMargin: {
            horizontal: 5,
            vertical: 5,
          },
        },
        plotOptions: {
          bar: {
                barHeight: '80%',
                distributed: true,
                horizontal: true,
                dataLabels: {
                  position: 'bottom'
                },
              }
        },
        noData: {
          text: '분석중...',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: '#1817E7',
            fontSize: '20px',
            fontFamily: "NanumBarunGothicB"
          }
        },
        colors: ['#33b2df', '#546E7A', '#d4526e', '#13d8aa', '#A5978B', '#2b908f', '#f9a3a4', '#90ee7e',
              '#f48024', '#69d2e7'
            ],
      },
      series: [{
            data: []
          }],
    };
  },
  props: {
    barChartData: {
      type: Array,
      default: () => [],
    },
    barChartFreq: {
      type: Array,
      default: () => [],
    },
    barChartSub: {
      type: Array,
      default: () => [],
    },
    barChartSubTitle: {
      type: Array,
      default: () => [],
    },
    barChartCategory: {
      type: Array,
      default: () => [],
    },
    totalFreq: {
      type: Number,
      default: 0
    },
    isChartInit: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    barChartData() {
      const newData = []
      for (const data of this.barChartData) {
        newData.push(data);
      }
      const newFreq = []
      for (const data of this.barChartFreq) {
        newFreq.push(data);
      }
      const newSub = []
      for (const data of this.barChartSub) {
        newSub.push(data);
      }
      const set = new Set(newSub)
      const uniqSub = [...set]

      const newSubTitle = []
      for (const data of this.barChartSubTitle) {
        newSubTitle.push(data);
      }
      const setTitle = new Set(newSubTitle)
      const uniqSubTitle = [...setTitle]


      const newCategory = []
      for (const data of this.barChartCategory) {
        newCategory.push(data);
      }
      this.setHeight(45*newCategory.length)
      this.setValues(newData, newCategory, this.totalFreq, newFreq, newSub, uniqSub, newSubTitle, uniqSubTitle)
    },
  },

  methods:{
    setHeight(value) {
      this.barChartHeight = value
    },
    setValues(newData, newCategory, totalFreq, newFreq, newSub, uniqSub, newSubTitle, uniqSubTitle){

      if (!this.isChartInit) {
        const chartOptionsBar = {
          noData: {
            text: '분석중...',
            style: {
              color: '#1817E7',
            }
          },
        };

        this.$refs.brandpinChartBar.updateOptions(chartOptionsBar, true);

        return;
      } 

      if (newData.length > 0) {  
        this.chartOptionsBar.xaxis = {
            categories: newCategory,
          }
        this.series = [{
            data: newData,
          }]      
        this.chartOptionsBar.tooltip = {
          shared: true,
          followCursor: true,
          intersect: false,
          x: {
            formatter(val, opt){
              if(newSubTitle[opt.dataPointIndex] == 'sub_brand'){
                return '라인 브랜드 > ' + newSub[opt.dataPointIndex] + ' > ' + val
              }else if(newSubTitle[opt.dataPointIndex] == 'product'){
                return '상품명 > ' + newSub[opt.dataPointIndex] + ' > ' + val
              }else{
                return '광고/인물 > ' + newSub[opt.dataPointIndex] + ' > ' + val
              }
              // return newSub[opt.dataPointIndex] + ' : ' + val
            }
          },
          y: {
            formatter(val, opt){
              return newFreq[opt.dataPointIndex].toLocaleString()
            },
            title: {
              formatter: function () {
                return ''
              }
            },
          },
        }

        this.chartOptionsBar.colors = [
          function({ value, dataPointIndex }) {
            if(newSubTitle[dataPointIndex] == 'sub_brand'){
              return "#FFB777"
            }else if(newSubTitle[dataPointIndex] == 'product'){
              return "#FF7070"
            }else{
              return "#70B870"
            }
              
            // const colorMapIdx = uniqSub.indexOf(newSub[dataPointIndex])
            // const colorMapIdx = uniqSubTitle.indexOf(newSubTitle[dataPointIndex])
            // const colorMap = 
            // ["#ff7f0e", "#FF0000", "#008000"]
            // // const colorMap = 
            // // ["#85a7eb", "#86cab9", "#e9b9e1", "#dc3912", "#990099", 
            // //   "#0099c6", "#dd4477", "#109618", "#b82e2e", "#316395", 
            // //   "#994499", "#66aa00", "#aaaa11", "#6633cc", "#e67300", 
            // //   "#8b0707", "#651067", "#329262", "#5574a6", "#3b3eac", 
            // //   "#055340", "#3e0a3f", "#2d3f63", "#617737", "#d445bc", 
            // //   "#22aa99", "#a68aa7", "#737d92", "#9ca885", "#d397c9",
            // //   "#3366cc", "#ff9900"
            // // ]
            // if(colorMapIdx > -1){
            //   return colorMap[colorMapIdx]
            // }else{
            //   colorMap[0]
            // }
          }
        ]


        
      }else{
        this.chartOptionsBar.xaxis = {
            categories: newCategory,
          }
        this.series = [{
            data: newData
          }]
        const chartOptionsBar = {
          noData: {
            text: '해당하는 키워드가 없습니다.',
            style: {
              color: '#FF009C',
            }
          },
        };

        this.$refs.brandpinChartBar.updateOptions(chartOptionsBar, true);
      }

      


    }
  }
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/chart-apex.scss";
</style>
